import { z } from 'zod';
/**
 * Schema for get-session - requires session token
 */
export const getSessionSchema = z.object({
    sessionToken: z.string().min(1, 'Session token is required'),
});
//# sourceMappingURL=get-session.schema.js.map